/*
Nomenclatura para la definicion de constantes:
	ACT_ + NOMBRE DEL MODULO (Action File) + Acción propiamente dicha

Ejemplos de nomenclatura:
	ACT_LOGIN_REGISTER
	ACT_EMPLEADOS_ADD
	ACT_EMPLEADOS_DELETE

Para acciones que solo cambian props (ejemplo).
	CHPROPS_LOGIN
	CHPROPS_EMPLEADOS
*/

export const ACT_AUTH_CHANGE = "ACT_AUTH_CHANGE"; 
export const ACT_APP_CHANGE = "ACT_APP_CHANGE"; 
export const ACT_EVT_CHANGE = "ACT_EVT_CHANGE"; 
export const ACT_PLC_CHANGE = "ACT_PLC_CHANGE"; 
export const ACT_USR_CHANGE = "ACT_USR_CHANGE"; 
export const ACT_TAG_CHANGE = "ACT_TAG_CHANGE"; 
export const ACT_ROL_CHANGE = "ACT_ROL_CHANGE"; 
export const ACT_NTF_CHANGE = "ACT_NTF_CHANGE";
export const ACT_NVT_CHANGE  = "ACT_NVT_CHANGE"

export const ACT_ABM_CHANGE = "ACT_ABM_CHANGE"; 
export const MODE_CRU_UPDATE = "UPDATE";
export const MODE_CRU_ADDELEMENT = "ADDELEMENT";
export const MODE_CRU_SHOW = "SHOW";
export const MODE_CRU_CREATE = "CREATE";
export const MODE_CRU_COPY = "COPY";
export const CHPROPS_LOGIN_RECOVERY_PASSWORD =
	"CHPROPS_LOGIN_RECOVERY_PASSWORD"; //CHANGE_PROPS_RECOVERY_PASSWORD
export const CHPROPS_AUTH_USER = "CHPROPS_AUTH_USER"; //LOGIN_USER
export const ACT_PERMISO_CHANGE = "ACT_PERMISO_CHANGE"; //CHANGE_PERMISO_PROPS
export const CHPROPS_LOGIN_REGISTER = "CHPROPS_LOGIN_REGISTER"; //ACTION_SET_COMPLETE_REGISTRATION
export const ACT_STATS_CHANGE = "ACT_STATS_CHANGE"


// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js